import { ReactNode } from 'react';
import { DrawerProps } from 'react-rainbow-components/components/Drawer';
import Close from 'components/icons/close';
import ButtonIcon from 'components/ButtonIcon';
import {
    HeaderActions, HeaderContainer, HeaderLabel, StyledDrawer,
} from './styled';

interface Props extends DrawerProps {
    headerActions?: ReactNode;
    hideCloseButton?: boolean;
}

const Drawer = ({
    onRequestClose,
    header,
    headerActions,
    hideCloseButton = false,
    ...props
}: Props) => (
    <StyledDrawer
        {...props}
        onRequestClose={onRequestClose}
        hideCloseButton
        header={(
            <HeaderContainer>
                <HeaderLabel>{header}</HeaderLabel>
                {headerActions && (
                    <HeaderActions>
                        {headerActions}
                    </HeaderActions>
                )}
                {!hideCloseButton && (
                    <ButtonIcon
                        icon={<Close />}
                        onClick={onRequestClose}
                    />
                )}
            </HeaderContainer>
        )}
    />
);

export default Drawer;
